export default {
  message: {
    cart: "購物車",
    home: "首頁",
    discountText: "所有優惠商品高達60%",
    headingTitle: "新產品",
    addToCart: "添加到購物車",
    price: "價格",
    rate: "評分",
    TotalPrice: "總價",
    goodNum: "數量",
    buyNow: "立即购买",
    addCart: "立即購買",
    productDetailTitle: "商品詳情",
    productRecommendationsTitle: "商品推薦",
    categoryTitle: "商品分類",
    hotgoodstitle: "熱賣商品",
    smallDetails: "本商品熱門銷售中",
    orderSale: "已售",
    msgLanguage: "加入成功",

    buyItNow: "現在就買",
    shipping: "航運",
    pay: "付款",
    back: "退回",
    support: "支持",
    shippingDesc: "來自我精心挑選的賣家",
    checkOut: "結賬",
    viewCart: "查看購物車",
    agreePrivacy: "我同意隱私政策",
    remove: "刪除",
    total: "總計",
    language: "語言",
    aboutUsText: "關於我們",
    aboutUsContent: `<div class="product__tab--content__step">
      <h2 class="product__tab--content__title">關於我們</h2>
      <p>我們是一家致力於為您提供高品質護膚產品的公司。 我們的使命是幫助您擁有健康、光滑和年輕的肌膚，從而增强您的自信和美麗。</p>
      <p>我們的產品是由經驗豐富的專家團隊精心研發，採用最先進的配方和科技，以確保您獲得最佳的護膚效果。 我們嚴格選擇原材料，只使用最純淨、天然的成分，讓您放心使用，無需擔心刺激或副作用。</p>
      <p>無論您的肌膚類型是幹性、油性還是敏感性，我們都有適合您的產品。 我們的產品線涵蓋了清潔、滋潤、抗衰老等多個方面，以滿足您不同的護膚需求。</p>
      <p>除了高品質的產品，我們還致力於為客戶提供卓越的服務體驗。 我們的客服團隊隨時為您提供幫助和建議，讓您在使用我們的產品時感到無憂無慮。</p>
    </div>`,
    contactUsText: "聯繫我們",
    contactUsContent: `<div class="product__tab--content__step">
    <h2 class="product__tab--content__title">聯繫我們</h2>
      <p>營業時間：每週上午 10 點至下午 6 點</p>
      <p>電子郵件：1571964822@qq.com</p>
      <p>公司：</p>
      <p>金瑞贸易有限公司 JINRUI TRADING CO.， LIMITED</p>
      <p>地址：香港尖沙咀科学博物馆道14号新曼陀广场9楼A区917B室 FLAT/RM 917B BLK A 9/F NEW MANDARIN PLAZA NO.14 SCIENCE MUSEUM RD TST HONG KONG</p>
      <p>Please note:Our goods are shipped in Guangzhou and the estimated arrival time is 7-15 days</p>
    </div>`,
    refundsText: "退貨與換貨",
    refundsContent: `<div class="product__tab--content__step">
      <h2 class="product__tab--content__title">退貨與換貨</h2>
      <p>客戶有權在收到產品後15天內申請退貨</p>
      <p>要獲得退貨資格，您的物品必須未使用並且處於與您收到時相同的狀態。它還必須在原始包裝中。</p>
      <p>為完成您的退貨，我們需要收據或購買證明。</p>
      <p>請不要將您購買的產品退回給製造商。</p>
      <p>退款（如適用）</p>
      <p>收到並檢查您的退貨後，我們將向您發送一封電子郵件，通知您我們已收到您退回的物品。我們還將通知您退款的批准或拒絕。</p>
      <p>如果您獲得批准，則將處理您的退款，並在一定天數內自動將信用額度應用到您的信用卡或原始付款方式。</p>
      <p>延遲或丟失退款（如果適用）</p>
      <p>如果您還沒有收到退款，請先再次檢查您的銀行帳戶。</p>
      <p>然後聯繫您的信用卡公司，您的退款可能需要一些時間才能正式發佈。</p>
      <p>接下來聯繫您的銀行。在發佈退款之前通常需要一些處理時間。</p>
      <p>如果您已完成所有這些操作，但仍未收到退款，請聯繫我們。</p>
      <p>銷售專案（如適用）</p>
      <p>只有正價商品可以退款，很遺憾，促銷商品無法退款。</p>
      <p>交易所（如適用）</p>
      <p>交易所（如適用）</p>
      <p>禮物</p>
      <p>如果該商品在購買並直接運送給您時被標記為禮物，您將收到相當於退貨價值的禮品積分。收到退回的物品後，將向您郵寄禮券。</p>
      <p>如果該商品在購買時未標記為禮物，或者送禮人將訂單商品寄給了他們自己稍後再送給您，我們將向送禮人退款，他會知道您的退貨情況。</p>
      <p>船運</p>
      <p>要退回您的產品，您應該先郵寄給我們以獲取詳細資訊</p>
      <p>退款政策：</p>
      <p>退款需扣除相關手續費</p>
      <p>退貨地址:韓國仁川西區石南洞650-41 1棟2層</p>
    </div>`,
    privacyText: "隱私政策",
    privacyContent: `
      <div class="product__tab--content__step">
        <h2 class="product__tab--content__title">隱私政策</h2>
        <p>我們如何處理您的資訊？</p>
        <p>當您從我們的商店購買商品時，作為買賣過程的一部分，我們會收集您提供給我們的個人資訊，例如您的姓名、地址和電子郵件地址。</p>
        <p>當您流覽我們的商店時，我們還會自動接收您電腦的互聯網協議 (IP) 地址，以便向我們提供有助於我們瞭解您的流覽器和操作系統的資訊。</p>
        <p>電子郵件行銷（如果適用）：在您允許的情況下，我們可能會向您發送有關我們商店、新產品和其他更新的電子郵件。</p>
        <p>隱私與安全</p>
        <p>作為我們常規業務過程的一部分，我們不會向任何人或任何公司出售、交易或出租個人身份資訊。但您也應妥善保管您的帳戶資訊，不得將帳戶資訊洩露給他人。</p>
        <p>我如何退訂？</p>
        <p>您可以使用任何電子郵件通訊底部的鏈接取消訂閱，或在您的網站用戶帳戶頁面中更改您的訂閱設置。</p>
        <p>聯繫我們</p>
        <p>如果您對本隱私政策或我們對您的資訊的處理有任何疑問、意見或要求，請隨時與我們聯繫。</p>
      </div>
    `,
    shippingText: "船運",
    shippingContent: `<div class="product__tab--content__step ">
      <h2 class="product__tab--content__title">船運</h2>
      <p>總交貨時間 = 處理時間 + 運輸時間</p>
      <p>客戶最多只需要支付一次運費（包括退貨）；退貨不向消費者收取退貨費用。</p>
      <p>處理時間：在發貨前，我們會進行品質控制檢查和測試，以確保產品在發貨前的品質。通常 2-7個工作日。但是，它也會受到商品庫存狀態的影響。對於存在庫存問題的熱門商品，處理時間可能為 2-9 個工作日。</p>
      <p>我們是海外網站，國際物流</p>
    </div>`,
    termsText: "條款和條件",
    termsContent: `<div class="product__tab--content__step">
    <h2 class="product__tab--content__title">條款和條件</h2>
    <strong class="h5">概述</strong>
    <p>我們提供本網站，包括本網站向您（用戶）提供的所有資訊、工具和服務，前提是您接受此處所述的所有條款、條件、政策和通知。</p>
    <p>通過訪問我們的網站和/或從我們這裏購買東西，您參與我們的“服務”並同意受以下條款和條件（“服務條款”、“條款”）的約束，包括這些附加條款和條件以及政策此處引用和/或可通過超鏈接獲得。這些服務條款適用於網站的所有用戶，包括但不限於作為流覽器、供應商、客戶、商家和/或內容貢獻者的用戶。</p>
    <p>在訪問或使用我們的網站之前，請仔細閱讀這些服務條款。通過訪問或使用網站的任何部分，您同意受這些服務條款的約束。如果您不同意本協議的所有條款和條件，則您不得訪問網站或使用任何服務。如果這些服務條款被視為要約，則接受明確限於這些服務條款。</p>
    <p>添加到當前商店的任何新功能或工具也應遵守服務條款。您可以隨時在此頁面上查看最新版本的服務條款。我們保留通過在我們的網站上發佈更新和/或更改來更新、更改或替換這些服務條款的任何部分的權利。您有責任定期檢查此頁面以瞭解更改。您在發佈任何更改後繼續使用或訪問網站即表示您接受這些更改。</p>
    <p>我們的商店託管在 Shopify Inc. 他們為我們提供線上電子商務平臺，使我們能夠向您銷售我們的產品和服務。</p>
    <ol>
      <li>
        <h5>1.線上商店條款</h5>
        <p>同意這些服務條款，即表示您至少已達到您所在州或居住省的成年年齡，或者您已達到您所在州或居住省的成年年齡，並且您已同意我們允許您的任何未成年家屬使用本網站。</p>
        <p>您不得將我們的產品用於任何非法或未經授權的目的，也不得在使用服務時違反您所在司法管轄區的任何法律（包括但不限於版權法）。您不得傳播任何蠕蟲或病毒或任何具有破壞性的代碼。</p>
        <p>違反或違反任何條款將導致您的服務立即終止。</p>
      </li>
      <li>
        <h5>2.一般條件</h5>
        <p>我們保留隨時以任何理由拒絕向任何人提供服務的權利。</p>
        <p>您瞭解您的內容（不包括信用卡資訊）可能會在未加密的情況下傳輸並涉及 (a) 通過各種網路傳輸；(b) 更改以符合和適應連接網路或設備的技術要求。信用卡資訊在通過網路傳輸期間始終是加密的。</p>
        <p>未經我們明確書面許可，您同意不復制、複製、複製、出售、轉售或利用服務的任何部分、服務的使用、服務的訪問或提供服務的網站上的任何聯繫方式.</p>
        <p>本協議中使用的標題僅為方便起見，不會限制或以其他方式影響這些條款。</p>
      </li>
      <li>
        <h5>3.資訊的準確性、完整性和及時性</h5>
        <p>如果本網站提供的資訊不准確、不完整或不最新，我們概不負責。本網站上的材料僅供一般參考，在未諮詢主要、更準確、更完整或更及時的資訊來源的情況下，不應依賴或用作決策的唯一依據。任何對本網站材料的依賴均由您自行承擔風險。</p>
        <p>本網站可能包含某些歷史資訊。歷史資訊不一定是最新的，僅供您參考。我們保留隨時修改本網站內容的權利，但我們沒有義務更新我們網站上的任何資訊。您同意您有責任監控我們網站的變化。</p>
      </li>
      <li>
        <h5>4.服務和價格的修改</h5>
        <p>我們產品的價格如有更改，恕不另行通知。</p>
        <p>我們保留隨時修改或終止服務（或其任何部分或內容）的權利，恕不另行通知。</p>
        <p>對於本服務的任何修改、價格變動、暫停或中止，我們不對您或任何第三方承擔任何責任。</p>
      </li>
      <li>
        <h5>5.產品或服務（如果適用）</h5>
        <p>某些產品或服務可能僅通過網站線上提供。這些產品或服務可能數量有限，只能根據我們的退貨政策進行退貨或換貨。</p>
        <p>我們已盡一切努力盡可能準確地展示出現在商店中的產品的顏色和圖像。我們無法保證您的電腦顯示器顯示的任何顏色都是準確的。</p>
        <p>我們保留權利，但沒有義務將我們的產品或服務的銷售限制在任何人、地理區域或司法管轄區。我們可以根據具體情況行使此權利。我們保留限制我們提供的任何產品或服務數量的權利。所有產品描述或產品定價可隨時更改，恕不另行通知，由我們自行決定。我們保留隨時停止任何產品的權利。在本網站上提供的任何產品或服務的任何報價在被禁止的情況下均無效。</p>
        <p>我們不保證您購買或獲得的任何產品、服務、資訊或其他材料的品質將滿足您的期望，或者服務中的任何錯誤將得到糾正。</p>
      </li>
      <li>
        <h5>6.帳單和帳戶資訊的準確性</h5>
        <p>我們保留拒絕您向我們下的任何訂單的權利。我們可以自行決定限制或取消每人、每戶或每筆訂單的購買數量。這些限制可能包括由同一客戶帳戶、同一信用卡和/或使用相同帳單和/或送貨地址的訂單或在同一客戶帳戶下的訂單。如果我們更改或取消訂單，我們可能會嘗試通過聯繫您在下訂單時提供的電子郵件和/或帳單地址/電話號碼來通知您。我們保留限制或禁止根據我們的判斷似乎是由經銷商、轉售商或分銷商下達的訂單的權利。</p>
        <p>您同意為在我們商店進行的所有購買提供最新、完整和準確的購買和帳戶資訊。您同意及時更新您的帳戶和其他資訊，包括您的電子郵件地址和信用卡號碼以及到期日期，以便我們可以完成您的交易並在需要時與您聯繫。</p>
        <p>有關更多詳細資訊，請查看我們的退貨政策</p>
      </li>
      <li>
        <h5>7.可選工具</h5>
        <p>我們可能會為您提供對第三方工具的訪問許可權，我們既不對其進行監控，也不對其進行任何控制或輸入。</p>
        <p>您承認並同意，我們“按原樣”和“可用”提供對此類工具的訪問，沒有任何類型的保證、陳述或條件，也沒有任何背書。對於因您使用可選的第三方工具而產生的或與之相關的任何責任，我們概不負責。</p>
        <p>您對通過網站提供的可選工具的任何使用完全由您自行承擔風險和自行決定，您應確保您熟悉並批准相關第三方提供商提供工具的條款。</p>
        <p>將來，我們還可能通過網站提供新服務和/或功能（包括發佈新工具和資源）。此類新功能和/或服務也應遵守這些服務條款。</p>
      </li>
      <li>
        <h5>8.第三方鏈接</h5>
        <p>通過我們的服務提供的某些內容、產品和服務可能包括來自第三方的材料。</p>
        <p>本網站上的第三方鏈接可能會將您定向到與我們無關的第三方網站。我們不負責檢查或評估內容或準確性，我們不保證也不會對任何第三方材料或網站或第三方的任何其他材料、產品或服務承擔任何責任或義務。</p>
        <p>對於與購買或使用商品、服務、資源、內容或與任何第三方網站相關的任何其他交易相關的任何傷害或損害，我們概不負責。請仔細閱讀第三方的政策和做法，並確保您在進行任何交易之前瞭解它們。有關第三方產品的投訴、索賠、疑慮或問題應直接向第三方提出。</p>
      </li>
      <li>
        <h5>9.用戶評論、回饋和其他意見</h5>
        <p>如果應我們的要求，您發送了某些特定的提交（例如參賽作品），或者在我們沒有要求的情況下，您發送了創意、建議、建議、計畫或其他材料，無論是線上、通過電子郵件、郵寄還是其他方式（統稱為“評論”），您同意我們可以隨時不受限制地編輯、複製、發佈、分發、翻譯和以其他方式在任何媒體中使用您轉發給我們的任何評論。我們沒有義務 (1) 對任何評論保密；(2) 對任何評論進行補償；(3) 回應任何評論。</p>
        <p>我們可能但沒有義務監控、編輯或刪除我們自行決定確定為非法、冒犯、威脅、誹謗、誹謗、色情、淫穢或其他令人反感或違反任何一方的知識產權或本服務條款的內容.</p>
        <p>您同意您的評論不會侵犯任何第三方的任何權利，包括版權、商標、隱私、人格或其他個人或所有權。您進一步同意，您的評論不會包含誹謗或其他非法、辱罵或淫穢材料，或包含可能以任何方式影響服務或任何相關網站運行的任何電腦病毒或其他惡意軟體。您不得使用虛假的電子郵件地址，假裝不是您自己，或以其他方式誤導我們或第三方關於任何評論的來源。您對您發表的任何評論及其準確性承擔全部責任。對於您或任何第三方發佈的任何評論，我們不承擔任何責任。</p>
      </li>
      <li>
        <h5>10.個人資訊</h5>
        <p>您通過商店提交的個人資訊受我們的隱私政策約束。查看我們的隱私政策</p>
      </li>
      <li>
        <h5>11.錯誤、不准確和遺漏</h5>
        <p>有時，我們網站或服務中的資訊可能包含與產品描述、定價、促銷、優惠、產品運費、運輸時間和可用性相關的印刷錯誤、不准確或遺漏。如果服務或任何相關網站上的任何資訊不准確，我們保留隨時更正任何錯誤、不准確或遺漏以及更改或更新資訊或取消訂單的權利，恕不另行通知（包括在您提交訂單後）</p>
        <p>我們沒有義務更新、修改或澄清服務或任何相關網站上的資訊，包括但不限於定價資訊，法律要求的除外。服務或任何相關網站上未應用指定的更新或刷新日期，應視為表明服務或任何相關網站上的所有資訊均已修改或更新。</p>
      </li>
      <li>
        <h5>12.禁止使用</h5>
        <p>除了服務條款中規定的其他禁令外，您不得使用本網站或其內容：(a) 用於任何非法目的；(b) 招攬他人進行或參與任何非法行為；(c) 違反任何國際、聯邦、省或州的法規、規則、法律或地方條例；(d) 侵犯或違反我們的知識產權或他人的知識產權；(e) 基於性別、性取向、宗教、種族、種族、年齡、國籍或殘疾進行騷擾、辱罵、侮辱、傷害、誹謗、誹謗、貶低、恐嚇或歧視；(f) 提交虛假或誤導性資訊；(g) 上傳或傳播病毒或任何其他類型的惡意代碼，這些代碼將或可能以任何方式使用，影響服務或任何相關網站、其他網站或互聯網的功能或操作；(h) 收集或追蹤他人的個人資訊；(i) 垃圾郵件、網路釣魚、醫藥、藉口、蜘蛛、爬網或抓取；(j) 出於任何淫穢或不道德的目的；(k) 干擾或規避服務或任何相關網站、其他網站或互聯網的安全功能。我們保留終止您違反任何禁止使用的服務或任何相關網站的權利。(j) 出於任何淫穢或不道德的目的；(k) 干擾或規避服務或任何相關網站、其他網站或互聯網的安全功能。我們保留終止您違反任何禁止使用的服務或任何相關網站的權利。(j) 出於任何淫穢或不道德的目的；(k) 干擾或規避服務或任何相關網站、其他網站或互聯網的安全功能。我們保留終止您違反任何禁止使用的服務或任何相關網站的權利。</p>
      </li>
      <li>
        <h5>13.免責聲明；責任限制</h5>
        <p>我們不保證、陳述或保證您對我們服務的使用不會中斷、及時、安全或無錯誤。</p>
        <p>我們不保證使用服務可能獲得的結果是準確或可靠的。</p>
        <p>您同意我們可以不時地無限期地刪除服務或隨時取消服務，恕不另行通知。</p>
        <p>您明確同意您自行承擔使用或無法使用該服務的風險。服務以及通過服務交付給您的所有產品和服務（除非我們明確聲明）“按原樣”和“可用”提供給您使用，沒有任何明示或明示的任何形式的陳述、保證或條件暗示的，包括所有關於適銷性、適銷品質、特定用途的適用性、耐用性、所有權和非侵權的默示保證或條件。</p>
        <p>在任何情況下，我們的董事、高級職員、員工、附屬公司、代理人、承包商、實習生、供應商、服務提供商或許可人均不對任何傷害、損失、索賠或任何直接、間接、附帶、懲罰性、特殊或後果性損害負責任何類型的損失，包括但不限於因您使用任何服務或使用服務獲得的任何產品，或以任何方式與您使用服務或任何產品相關的任何其他索賠，包括但不限於任何內容的任何錯誤或遺漏，或任何損失或由於使用服務或發佈、傳輸的任何內容（或產品）而導致的任何類型的損害，或以其他方式通過服務提供，即使已被告知其可能性。</p>
        <p>由於某些州或司法管轄區不允許排除或限制間接或附帶損害的責任，因此在這些州或司法管轄區，我們的責任應限於法律允許的最大範圍內。</p>
      </li>
      <li>
        <h5>14.賠償</h5>
        <p>您同意對我們公司和我們的母公司、子公司、附屬公司、合作夥伴、管理人員、董事、代理人、承包商、許可人、服務提供商、分包商、供應商、實習生和員工進行賠償、辯護並使其免受任何索賠或要求的損害，包括合理的任何第三方因您違反這些服務條款或它們通過引用合併的檔，或您違反任何法律或第三方的權利而產生的律師費。</p>
      </li>
      <li>
        <h5>15.可分割性</h5>
        <p>如果本服務條款的任何條款被確定為非法、無效或不可執行，則該條款仍應在適用法律允許的最大範圍內可執行，不可執行部分應視為與本條款分離服務，此類決定不應影響任何其他剩餘條款的有效性和可執行性。</p>
      </li>
      <li>
        <h5>16.終止</h5>
        <p>就所有目的而言，雙方在終止日期之前產生的義務和責任應在本協議終止後繼續有效。</p>
        <p>這些服務條款在您或我們終止之前有效。您可以隨時通過通知我們您不再希望使用我們的服務或停止使用我們的網站來終止這些服務條款。</p>
        <p>如果我們單方面判斷您未能或我們懷疑您未能遵守本服務條款的任何條款或規定，我們也可以隨時終止本協議，恕不另行通知，您仍將對所有到期款項負責至並包括終止日期；和/或因此可能拒絕您訪問我們的服務（或其任何部分）。</p>
      </li>
      <li>
        <h5>17.完整協議</h5>
        <p>我們未能行使或執行本服務條款的任何權利或規定，並不構成對該權利或規定的放棄。</p>
        <p>這些服務條款以及我們在本網站上發佈的或與服務相關的任何政策或操作規則構成您與我們之間的完整協議和諒解，並約束您對服務的使用，取代任何先前或同期的協議、通訊和建議，無論是口頭還是書面，您和我們之間（包括但不限於服務條款的任何先前版本）。</p>
        <p>對本服務條款的解釋如有歧義，不得對起草方作出不利解釋。</p>
      </li>
      <li>
        <h5>18.服務條款的變更</h5>
        <p>您可以隨時在此頁面查看最新版本的服務條款。</p>
        <p>我們保留自行決定通過在我們的網站上發佈更新和更改來更新、更改或替換這些服務條款的任何部分的權利。您有責任定期查看我們的網站以瞭解更改。在發佈對這些服務條款的任何更改後，您繼續使用或訪問我們的網站或服務即表示您接受這些更改</p>
      </li>
      <li>
        <h5>19.適用法律</h5>
        <p>這些服務條款以及我們向您提供服務所依據的任何單獨協議均應受當地法律管轄並根據當地法律進行解釋。</p>
      </li>
    </ol>
  </div>`,
  },
  // 商品列表
  // productList: [
  //   {
  //     id: 1,
  //     imgUrl: "pro1-1.jpg",
  //     title: "SASAVIN蛋白棒",
  //     singlePrice: 255.88,
  //     bigProduct:['pro1-2.png','pro1-3.png']
  //   },
  //   {
  //     id: 2,
  //     imgUrl: "pro2-1.jpg",
  //     title: "朵匠、优姿轻解素、益生元多肽片压片糖果",
  //     singlePrice: 348.94,
  //     bigProduct:['pro2-2.jpg','pro2-3.jpg']

  //   },
  //   {
  //     id: 3,
  //     imgUrl: "pro3-1.jpg",
  //     title: "亨德仁源堂油切分解素双菇多肽粉固体饮料",
  //     singlePrice: 223.31,
  //     bigProduct:['pro3-2.jpg','pro3-3.jpg']

  //   },
  //   {
  //     id: 4,
  //     imgUrl: "pro4-1.jpg",
  //     title: "极魅曲然堂、低脂高纤型代餐营养粉",
  //     singlePrice: 321.00,
  //     bigProduct:['pro4-2.jpg','pro4-3.jpg']

  //   },
  //   {
  //     id: 5,
  //     imgUrl: "pro5-1.jpg",
  //     title: "蓝莓复合益生元固体饮料",
  //     singlePrice: 358.23,
  //     bigProduct:['pro5-2.jpg','pro5-3.jpg']

  //   },
  //   {
  //     id: 6,
  //     imgUrl: "pro6-1.jpg",
  //     title: "诺丽果低聚果糖压片",
  //     singlePrice: 348.94,
  //     bigProduct:['pro6-2.png','pro6-3.png']

  //   },
  //   {
  //     id: 7,
  //     imgUrl: "pro7-1.jpg",
  //     title: "奇亚籽固体饮料",
  //     singlePrice: 348.94,
  //     bigProduct:['pro7-2.jpg','pro7-3.jpg']

  //   },
  //   {
  //     id: 8,
  //     imgUrl: "pro8-1.jpg",
  //     title: "轻姿溶解素",
  //     singlePrice: 702.50,
  //     bigProduct:['pro8-2.jpg','pro8-3.jpg']

  //   },
  //   {
  //     id: 9,
  //     imgUrl: "pro9-1.jpg",
  //     title: "神奇粉末，固体饮料",
  //     singlePrice: 214.03,
  //     bigProduct:['pro9-2.jpg','pro9-3.png']

  //   },
  //   {
  //     id: 10,
  //     imgUrl: "pro10-1.jpg",
  //     title: "神奇粉末益生菌果蔬植物酵素粉",
  //     singlePrice: 348.94,
  //     bigProduct:['pro10-2.jpg','pro10-3.png']

  //   },
  //   {
  //     id: 11,
  //     imgUrl: "pro11-1.jpg",
  //     title: "新活力因子",
  //     singlePrice: 241.93,
  //     bigProduct:['pro11-2.png','pro11-3.jpg','pro11-4.jpg']

  //   },
  //   {
  //     id: 12,
  //     imgUrl: "pro12-1.jpg",
  //     title: "新--芊润易简玫奇亚籽固体饮料",
  //     singlePrice: 348.94,
  //     bigProduct:['pro12-2.png','pro12-3.png']

  //   },
  //   {
  //     id: 13,
  //     imgUrl: "pro13-1.jpg",
  //     title: "伊美源、轻轻果冻果味型果冻",
  //     singlePrice: 348.94,
  //     bigProduct:['pro13-2.jpg','pro13-3.jpg']

  //   },
  //   {
  //     id: 14,
  //     imgUrl: "pro14-1.jpg",
  //     title: "植物三调茶",
  //     singlePrice: 348.94,
  //     bigProduct:['pro14-2.jpg','pro14-3.png','pro14-4.png']

  //   },
  //   {
  //     id: 15,
  //     imgUrl: "pro15-1_zh_hk.png",
  //     title: "補差價",
  //     singlePrice: 1,
  //     bigProduct:[]
  //   },
  // ],
  productList: [],

  cartList: [],
  retail: {
    id: 15,
    imgUrl: "pro15-1_zh_hk.png",
    title: "補差價",
    singlePrice: 1,
    isRetail: true,
  },
};
